import { useQuery } from "@tanstack/react-query";
import { apiGetLangList } from "../service";
import queryKey from "../../../enumerations/queryKey";

export const useGetLangList = (options) => {
  return useQuery(
    [queryKey.LANG_LIST],
    () => apiGetLangList().then((res) => {
      const langList = []
      const allLangsData = res.data.data;
      allLangsData?.map((item) => {
        langList.push({
          label: item.name,
          value: item.language
        })
      })
      return langList;
    }),
    {
      ...options,
    }
  );
};
